// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalContactCall_backdrop__yA1s0","modal":"ModalContactCall_modal__I7ev6","slide-down":"ModalContactCall_slide-down__9lUzB","close":"ModalContactCall_close__lNmt0"};